import { makeStyles } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';

/** Teble */
const useTableStyle = makeStyles(() => ({
  root: { tableLayout: 'fixed' },
}));

/** TebleRow */
const useTableRowStyle = makeStyles((theme) => ({
  root: {
    '&.even': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  selected: {
    '&.even': {
      backgroundColor:
        theme.palette.secondary.main +
        Math.ceil(255 * theme.palette.action.selectedOpacity).toString(16),
    },
  },
}));

/** TebleCell */
const useTableCellStyle = makeStyles((theme) => ({
  root: {
    border: `1px solid ${blueGrey['100']}`,
    fontSize: '.95em',
    wordBreak: 'break-word',
  },
  head: {
    backgroundColor: theme.palette.primary.dark,
    fontWeight: 'bold',
    fontSize: '1em',
    color: theme.palette.primary.contrastText,
    textAlign: 'center',
  },
  sizeSmall: {
    padding: '6px 8px',
  },
}));

export { useTableRowStyle, useTableCellStyle };
export default useTableStyle;
